export const fitStringContentToHeightIfPossible = (DOMElement, targetElementHeight, originalFontSize, minFontSize) => {
  if (getHeightOfElement(DOMElement) > targetElementHeight) {
    // Start halfway so we do less iterations
    const targetElementFontSize = originalFontSize - Math.floor((originalFontSize - minFontSize) / 2);
    setIntFontSizeOfElement(DOMElement, targetElementFontSize);
    if (getHeightOfElement(DOMElement) > targetElementHeight) {
      shrinkHeadingTextToFix(DOMElement, targetElementHeight, minFontSize, originalFontSize);
    } else {
      increaseHeadingTextWhileFit(DOMElement, targetElementHeight, originalFontSize);
    }
  }
};

const increaseHeadingTextWhileFit = (headingElement, headingElementBaseHeight, headingElementOriginalFontSize) => {
  // Increase from here
  while (getHeightOfElement(headingElement) <= headingElementBaseHeight && getIntFontSizeOfElement(headingElement) < headingElementOriginalFontSize) {
    setIntFontSizeOfElement(headingElement, getIntFontSizeOfElement(headingElement) + 1);;
  }
};

const shrinkHeadingTextToFix = (headingElement, headingElementBaseHeight, minHeadingElementFontSize, headingElementOriginalFontSize) => {
  //decrease from here
  while (getHeightOfElement(headingElement) > headingElementBaseHeight && getIntFontSizeOfElement(headingElement) > minHeadingElementFontSize) {
    setIntFontSizeOfElement(headingElement, getIntFontSizeOfElement(headingElement) - 1);
  }
  if (getHeightOfElement(headingElement) > headingElementBaseHeight && getIntFontSizeOfElement(headingElement) === minHeadingElementFontSize) {
    setIntFontSizeOfElement(headingElement, headingElementOriginalFontSize);
  }
};

const getHeightOfElement = (element) => {
  return element.getBoundingClientRect().height;
};

const getIntFontSizeOfElement = (element) => {
  return parseInt(element.style.fontSize.replace("px", ""));
};

const setIntFontSizeOfElement = (element, size) => {
  element.style.fontSize = `${size}px`;
};